module.exports = {"331127001":"红星街道","331127002":"鹤溪街道","331127101":"渤海镇","331127102":"东坑镇","331127103":"英川镇","331127104":"沙湾镇","331127201":"大均乡","331127202":"澄照乡","331127203":"梅岐乡","331127205":"郑坑乡","331127208":"大漈乡","331127209":"景南乡","331127210":"雁溪乡","331127212":"鸬鹚乡","331127213":"梧桐乡","331127214":"标溪乡","331127215":"毛垟乡","331127216":"秋炉乡","331127217":"大地乡","331127218":"家地乡","331127219":"九龙乡"}


//////////////////
// WEBPACK FOOTER
// ./src/town/331127.json
// module id = 953
// module chunks = 0